import Vue from 'vue'
import Router, { Route } from 'vue-router'
import Store from '@/store'
import AppModule from '@/store/modules/app.module'
import Shell from '@/layout/Shell.vue'
import { getModule } from 'vuex-module-decorators'
import NProgress from 'nprogress'
import firebase from '@/firebase/firebaseInit'
import AuthApi from '../api/AuthApi'

Vue.use(Router)

const authApi = new AuthApi()
let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      component: () =>
        import(/* webpackChunkName: "auth" */ '@/views/auth/Login.vue'),
      meta: { hidden: true },
    },
    {
      path: '/access-denied',
      component: () => import('@/views/access-denied/AccessDenied.vue'),
    },
    {
      path: '/',
      component: Shell,
      redirect: '/home',
      children: [
        {
          path: 'home',
          component: () =>
            import(
              /* webpackChunkName: "home" */ '@/views/galaxy/generalGrid/index.vue'
            ),
          name: 'Home',
          meta: {
            title: 'Home',
            icon: 'home',
            requiresAuth: true,
            affix: true,
            reportId: 1,
            dataUrl: '/FSGalaxyReportingApi/api/v1/ProductionSummaryReport',
            links: [
              {
                name: 'Grid.vue',
                url:
                  'https://github.com/FASTSIGNS/FS.Onyx/blob/master/src/views/galaxy/generalGrid/Grid.vue',
                avatar: 'logos:vue',
              },
              {
                name: 'Index.vue',
                url:
                  'https://github.com/FASTSIGNS/FS.Onyx/blob/master/src/views/galaxy/generalGrid/index.vue',
                avatar: 'logos:vue',
              },
            ],
          },
        },
        {
          path: 'home/MarginDetailReport',
          component: () =>
            import(
              /* webpackChunkName: "home" */ '@/views/galaxy/generalGrid/index.vue'
            ),
          name: 'Margin',
          meta: {
            title: 'Margin',
            icon: 'home',
            requiresAuth: true,
            affix: true,
            reportId: 2,
            dataUrl: '/FSGalaxyReportingApi/api/v1/MarginDetailReport',
            links: [
              {
                name: 'Grid.vue',
                url: 'MarginDetailReport',
                avatar: 'logos:vue',
              },
              {
                name: 'Index.vue',
                url: 'MarginDetailReport',
                avatar: 'logos:vue',
              },
            ],
          },
        },
        {
          path: 'home/AccountingRTBSummaryReport',
          component: () =>
            import(
              /* webpackChunkName: "home" */ '@/views/galaxy/generalGrid/index.vue'
            ),
          name: 'Accounting RTB Summary Report',
          meta: {
            title: 'Accounting RTB Summary Report',
            icon: 'home',
            requiresAuth: true,
            affix: true,
            reportId: 3,
            dataUrl: '/FSGalaxyReportingApi/api/v1/AccountingRTBReport',
            links: [
              {
                name: 'Grid.vue',
                url:
                  'https://github.com/FASTSIGNS/FS.Onyx/blob/master/src/views/galaxy/generalGrid/Grid.vue',
                avatar: 'logos:vue',
              },
              {
                name: 'Index.vue',
                url:
                  'https://github.com/FASTSIGNS/FS.Onyx/blob/master/src/views/galaxy/generalGrid/index.vue',
                avatar: 'logos:vue',
              },
            ],
          },
        },
        {
          path: 'home/EclipseJobsReport',
          component: () =>
            import(
              /* webpackChunkName: "home" */ '@/views/galaxy/generalGrid/index.vue'
            ),
          name: 'Eclipse Jobs Report',
          meta: {
            title: 'Eclipse Jobs Report',
            icon: 'home',
            requiresAuth: true,
            affix: true,
            reportId: 19,
            dataUrl: '/FSGalaxyReportingApi/api/v1/EclipseJobsReport',
            links: [
              {
                name: 'Grid.vue',
                url:
                  'https://github.com/FASTSIGNS/FS.Onyx/blob/master/src/views/galaxy/generalGrid/Grid.vue',
                avatar: 'logos:vue',
              },
              {
                name: 'Index.vue',
                url:
                  'https://github.com/FASTSIGNS/FS.Onyx/blob/master/src/views/galaxy/generalGrid/index.vue',
                avatar: 'logos:vue',
              },
            ],
          },
        },
      ],
    },
  ],
})

let appModule = getModule(AppModule, Store)

router.beforeEach(async (to, from, next) => {
  const user: any = firebase.auth().currentUser
  const userInfo = user ? await authApi.getUserInfo(user.uid) : ''
  const groups = user ? await authApi.getGroups(userInfo) : []

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    user ? userAuth(to, next, groups) : next('/login')
  } else if (to.path == '/login') {
    user ? next('/home') : next()
  } else {
    next()
  }

  const onyxReader = groups.includes('national-accounts') || groups.includes('accounting') || groups.includes('accounting-restricted') || groups.includes('executive') || groups.includes('it')

  if (to.path == '/access-denied' && onyxReader) {
    next('/home')
  }
})

router.beforeResolve((to, from, next) => {
  if (to.name) {
    NProgress.start()
  }
  next()
})

router.afterEach((to, from) => {
  NProgress.done()
})

const userAuth = async (to: Route, next: any, groups: Array<string>) => {
  const onyxReader = groups.includes('national-accounts') || groups.includes('accounting') || groups.includes('accounting-restricted') || groups.includes('executive') || groups.includes('it')
  if (onyxReader) {
    appModule.SET_CODE_LINKS(to.meta.links)
    appModule.SET_REPORT_ID(to.meta.reportId)
    appModule.SET_DETAIL_ID(to.meta.detailId)
    appModule.SET_REPORT_DATA_URL(to.meta.dataUrl)
    next()
    return
  } else {
    next('/access-denied')
    return
  }
}

export default router
